/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyDetailsForUserResponse
 */
export interface CompanyDetailsForUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    clientDepartment?: string;
    /**
     * The ID of the company. Useful to enforce the user identity.
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    companyId: string;
    /**
     * The company name we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    companyName?: string;
    /**
     * The website URL of the company
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    companyWebsiteUrl?: string;
    /**
     * The company size we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    companySize?: string;
    /**
     * The company industry we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof CompanyDetailsForUserResponse
     */
    companyIndustry?: string;
}

/**
 * Check if a given object implements the CompanyDetailsForUserResponse interface.
 */
export function instanceOfCompanyDetailsForUserResponse(value: object): value is CompanyDetailsForUserResponse {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function CompanyDetailsForUserResponseFromJSON(json: any): CompanyDetailsForUserResponse {
    return CompanyDetailsForUserResponseFromJSONTyped(json, false);
}

export function CompanyDetailsForUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailsForUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientDepartment': json['clientDepartment'] == null ? undefined : json['clientDepartment'],
        'companyId': json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyWebsiteUrl': json['companyWebsiteUrl'] == null ? undefined : json['companyWebsiteUrl'],
        'companySize': json['companySize'] == null ? undefined : json['companySize'],
        'companyIndustry': json['companyIndustry'] == null ? undefined : json['companyIndustry'],
    };
}

export function CompanyDetailsForUserResponseToJSON(value?: CompanyDetailsForUserResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientDepartment': value['clientDepartment'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'companyWebsiteUrl': value['companyWebsiteUrl'],
        'companySize': value['companySize'],
        'companyIndustry': value['companyIndustry'],
    };
}

